import { action, computed, observable, runInAction } from 'mobx';

import { bind as bound } from 'bind-decorator';
import { computedFn } from 'mobx-utils';
import Api from 'tm3-core/api';
import { cache } from 'tm3-core/cache';
import featureFlag from 'tm3-core/stores/feature-store';

export class ProntoCache {
  @observable prontoNetworkServices = {};
  @observable prontoInvoiceTemplates = {};

  @action.bound
  onConfigure() {
    return new Promise((resolve, reject) => {
      if (cache.isEClinic) return resolve(true);
      Api.post('/api/pronto/cache/load').then((res) => {
        const { result } = res.body;

        let networkServices = new ProntoNetworkServices();
        let invoiceTemplates = new ProntoInvoiceTemplates();

        networkServices.onLoad(result.services);
        invoiceTemplates.onLoad(result.invoices);

        runInAction(() => {
          this.prontoNetworkServices = networkServices;
          this.prontoInvoiceTemplates = invoiceTemplates;
        });

        let req = {
          prontoNetworkServices: networkServices,
          prontoInvoiceTemplates: invoiceTemplates
        };

        resolve(req);
      });
    });
  }
}

class CacheObject {
  @observable loading = true;
  all = observable.map();

  @action.bound
  onLoad(res) {
    this.all.replace(res || {});
    this.loading = false;
  }

  getById = computedFn(this._getById);

  @bound
  _getById(id) {
    return this.all.get(id);
  }
}

class ProntoNetworkServices extends CacheObject {
  public orderBy: string = 'discipline';
  getServiceName = computedFn(this._getServiceName);
  getAll = computedFn(this._getAll);

  @bound
  _getServiceName(networkServiceId) {
    const service = this.getById(networkServiceId);

    const prontoServiceName =
      !!service && service.serviceName ? service.serviceName : 'Unknown Service';

    return prontoServiceName;
  }

  @bound
  _getAll() {
    let services: any[] = [];

    const res = Array.from(this.all._data.values()) || [];
    res.forEach((service) => {
      services.push(service.value);
    });

    const { orderBy } = this;
    try {
      if (orderBy.length > 0) {
        services.sort((a, b) => {
          if (!a[orderBy] || !b[orderBy]) {
            return 0;
          }
          return a[orderBy].localeCompare(b[orderBy]);
        });
      }
    } catch {
      // no ordering is going to happen
      console.error('A problem arose when attempting to order these items');
    }
    return services;
  }
}
class ProntoInvoiceTemplates extends CacheObject {}

export default new ProntoCache();
